"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const styled_1 = require("./styled");
const StyledEmptyWrapper = props => {
    const { children, count = 0, isLoading = false, message = "messages.empty-list" } = props;
    if (count) {
        return children;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.Root, { children: (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: isLoading ? "messages.loading" : message }) }) }));
};
exports.StyledEmptyWrapper = StyledEmptyWrapper;
//# sourceMappingURL=index.js.map